<template>
  <div>
    <v-btn color="transparent" tile elevation="0" @click.stop="loginKeycloak" class="botaoLogar">
      <v-icon left>mdi-login</v-icon>
      Entrar
    </v-btn>
  </div>
</template>

<script>
import {useAuth} from "@/services/kcAuth";

export default {
  name: "Login",
  methods: {
    loginKeycloak() {
      let {auth, login} = useAuth()
      if (auth.authenticated) {
        this.$router.push("/oauth-redirect")
        return
      }
      login()
    },
  }
}
</script>

<style scoped>
.botaoLogar {
  margin-top: 12px;
}
</style>
